import React from 'react';
import Navbar from '../components/Navbar';
import SeoHead from '../components/SeoHead';
import Footer from '../components/Footer';

const About = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900">
      <SeoHead
          title="À propos de PulseCIO - Solution SaaS pour toutes les organisations"
          description="Découvrez PulseCIO, la solution SaaS de communication et collaboration pour DSI, PME, associations et particuliers. Optimisez la gestion de vos messages, tâches et communications. Plateforme moderne, sécurisée et conforme RGPD."
          breadcrumb={{ name: "À propos", path: "/about" }}
      />
      <Navbar />
      <main className="flex-1 container mx-auto px-6 py-20">
        <h1 className="text-3xl font-bold mb-6 text-black dark:text-white">À propos de PulseCIO</h1>
        <div className="prose dark:prose-invert max-w-none">
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            PulseCIO est une application SaaS professionnelle conçue pour faciliter la gestion, la centralisation et le partage sécurisé de messages, notes et tâches. Notre plateforme cloud s'adapte à tous types d'organisations : grandes entreprises avec DSI & CIO Office, PME, TPE, associations et même particuliers cherchant à optimiser leur communication et leur productivité.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Notre vision</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Nous croyons que toute organisation, quelle que soit sa taille, mérite des outils performants pour structurer sa communication, gérer ses tâches et collaborer efficacement. PulseCIO unifie ces besoins dans une seule plateforme accessible, sécurisée et conforme RGPD.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Auteur et expertise</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Ce projet est conçu et maintenu par Mathieu Lalande, expert en solutions cloud, sécurité informatique et productivité numérique. L'activité est exercée sous le statut d'auto-entreprise (micro-entrepreneur).
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Statut et conformité</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Statut juridique : auto-entreprise (micro-entrepreneur). Pas de capital social de départ. PulseCIO s'engage à respecter la conformité RGPD et les meilleures pratiques de sécurité pour les applications SaaS professionnelles.
          </p>
        </div>
      </main>
      <div className="w-full flex justify-center mt-12 mb-2">
        <a href="/" className="inline-flex items-center px-5 py-2 rounded-lg bg-blue-600 text-white font-semibold shadow hover:bg-blue-700 transition">
          ← Retour à la page principale
        </a>
      </div>
      <Footer />
    </div>
  );
};

export default About;